"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeIn = void 0;
class EventTypeIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeIn.attributeTypeMap;
    }
}
exports.EventTypeIn = EventTypeIn;
EventTypeIn.discriminator = undefined;
EventTypeIn.attributeTypeMap = [
    {
        "name": "archived",
        "baseName": "archived",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "schemas",
        "baseName": "schemas",
        "type": "{ [key: string]: any; }",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeIn.js.map